export interface Account {
  accountId?: string;
  organizationId?: number;
  role?: string;
  username?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  fiscalCode?: string;
  code?: string;
  qualificationName?: string;
  qualificationDescription?: string;
  agentKey?: string;
  enabled?: boolean;
}

export const ACCOUNT_ROLES: { id: string; description: string }[] = [
  { id: 'ORGANIZATION_ADMIN', description: 'Amministratore (ente)' },
  { id: 'APP_GUEST_USER', description: 'Ausiliario' },
  { id: 'APP_USER', description: 'Agente' },
];
